import {
  drawerWidth,
  headerHeight,
  transition,
  container
} from "assets/jss/index.js";

const appStyle = theme => ({
  wrapper: {
    position: "relative",
    paddingTop: headerHeight,
    height: "100%"
  },
  mainPanel: {
    overflow: "auto",
    position: "relative",
    float: "right",
    ...transition,
    maxHeight: "100%",
    width: "100%",
    overflowScrolling: "touch",
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  content: {
    padding: "20px 15px",
    minHeight: "calc(100vh - 123px)"
  },
  container,
});

export default appStyle;
